import { combineReducers } from 'redux';
import { merge, values, omitBy } from 'lodash';

import {
  fetchArtifactHealthApplicationStatusesTypes,
  fetchArtifactHealthPlatformStatusesTypes
} from './../actions/types';
import {
  LOCATION_CHANGE,
  CHANGE_ARTIFACT_HEALTH_FILTER,
  CHANGE_ARTIFACT_HEALTH_ORDER,
} from './../actions';
import { propertyReducer, propertyAccumulatorReducerByFunc } from './../helpers/utils';
import { artifactHealth } from './../helpers';

const defaultState = { 'orderBy': Object.keys(artifactHealth.ARTIFACT_HEALTH_ORDERS)[0] };
const order = (state = defaultState, action) => {
  switch (action.type) {
    case CHANGE_ARTIFACT_HEALTH_ORDER:
      return {
        ...state,
        'orderBy': action.orderBy
      };
    default:
      return state;
  }
};

const applications = (state = {}, action) => {
  switch (action.type) {
    case fetchArtifactHealthApplicationStatusesTypes.success:
      const app = action.response;
      return merge({}, state, { [app.platform]: { [app.name]: app }});
    case LOCATION_CHANGE:
      return {};
    default:
      return state;
  }
};

const platforms = (state = {}, action) => {
  switch (action.type) {
    case fetchArtifactHealthPlatformStatusesTypes.success:
      return propertyReducer(
        action.response,
        p => p.platform,
        p => ({
          ...p,
          statuses: propertyAccumulatorReducerByFunc(
            p.statuses, a => artifactHealth.getArtifactHealthStatusByCode(a.status).name
          )
        })
      );
    default:
      return state;
  }
};

const filters = (state = {}, action) => {
  switch (action.type) {
    case CHANGE_ARTIFACT_HEALTH_FILTER:
      return {
        ...state,
        [action.filter]: action.checked
      };
    case LOCATION_CHANGE:
      return {};
    default:
      return state;
  }
};

const reducer = combineReducers({
  platforms,
  applications,
  filters,
  order
});
export default reducer;

export const getArtifactHealthFilters = state => state.artifactHealth.filters;
export const getArtifactHealthOrder = state => state.artifactHealth.orderBy;
export const getArtifactHealthPlatforms = state => values(state.artifactHealth.platforms);
export const getArtifactHealthPlatform = (state, platform) => {
  const p = state.artifactHealth.platforms[platform];
  if (!p) {
    return p;
  }

  const fs = Object.keys(omitBy(getArtifactHealthFilters(state), v => v !== true));
  return {
    ...p,
    statuses: artifactHealth.sortApplications(
      artifactHealth.filterApplications(p.statuses, fs),
      state.artifactHealth.order.orderBy)
  };
};
export const getArtifactHealthPlatformApplication = (state, platform, application) => {
  const p = state.artifactHealth.applications[platform];
  if (!p) {
    return undefined;
  }

  return p[application];
};


// WEBPACK FOOTER //
// src/reducers/artifactHealth.js